function toggleShopFilter() {
	document.querySelectorAll('.filter-btn').forEach((btn) => {
		btn.addEventListener('click', function () {
			btn.classList.toggle('active');
			document.getElementById('product-loop-filters').classList.toggle('active');
		});
	});

}

export {toggleShopFilter};